// src/components/WhatsAppProvider/WhatsAppProvider.jsx
import React, { useState } from 'react';
import '../css/WhatsappProvider.css';

const WhatsAppProvider = ({ phoneNumber = "905xxxxxxxxx" }) => {
    const [isHovered, setIsHovered] = useState(false);

    const handleWhatsAppClick = () => {
        window.open(`https://wa.me/${phoneNumber}`, '_blank');
    };

    return (
        <div
            className="whatsapp-provider"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={handleWhatsAppClick}
        >
            <div className="whatsapp-icon">
                <i className="pi pi-whatsapp"></i>
            </div>
            {isHovered && (
                <div className="whatsapp-tooltip">
                    İletişime geçin !
                </div>
            )}
        </div>
    );
};

export default WhatsAppProvider;